import type { JSX } from "react"

/**
 * A headline that arrives letter by letter. Screen readers get the whole text once (aria-label);
 * the letters are decoration, grouped by word so a line never breaks inside one. With reduced
 * motion the text simply shows.
 */
export function RevealText({ text, as: Tag = "h1", step = 22, className }: {
  text: string
  as?: keyof JSX.IntrinsicElements
  /** Milliseconds between letters. */
  step?: number
  className?: string
}) {
  let i = 0
  return (
    <Tag className={`nst-chars${className ? ` ${className}` : ""}`} aria-label={text}>
      {text.split(" ").map((word, w) => (
        <span className="nst-word" aria-hidden="true" key={w}>
          {[...word].map((ch) => (
            <span className="nst-char" key={i} style={{ animationDelay: `${(i++) * step}ms` }}>{ch}</span>
          ))}
          {w < text.split(" ").length - 1 ? <span className="nst-char nst-space">{" "}</span> : null}
        </span>
      ))}
    </Tag>
  )
}
